export const getExtrasDescription = (tiers: any) => {
  const extraTiers = [...tiers]
  const description =
    extraTiers.filter(t => t?.selected).map(t => t?.description)[0] ||
    extraTiers.find(t => t?.amountInPounds === Math.min(...extraTiers.map(t => (t ? t.amountInPounds : 0))))
      ?.description

  return `${description}.`
}
